import request from '../utils/https'

// 通知列表
export function getNotificationList (params) {
    return request({
        url: '/notification/list',
        method: 'post',
        data:params
    })
}

// 未讀通知數量
export function getNotificationCount (params) {
    return request({
        url: '/notification/count',
        method: 'post',
        data:params
    })
}

// 讀取通知
export function readNotification (params) {
    return request({
        url: '/notification/read',
        method: 'post',
        data:params
    })
}


